module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_3009.aab12c43.png";